import { render, staticRenderFns } from "./AppBase.vue?vue&type=template&id=9dc7bd04&"
import script from "./AppBase.vue?vue&type=script&lang=js&"
export * from "./AppBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VApp,VFadeTransition})
